module.exports = __webpack_public_path__ + "static/GalanoGrotesque-Regular-75beea9e426f8ad08576ba5352588cae.woff2";